import { render, staticRenderFns } from "./PlaylistLibrary.vue?vue&type=template&id=665a88be"
import script from "./PlaylistLibrary.vue?vue&type=script&lang=js"
export * from "./PlaylistLibrary.vue?vue&type=script&lang=js"
import style0 from "./PlaylistLibrary.vue?vue&type=style&index=0&id=665a88be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports